import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['count'];

  // Method to refresh the comment count when navigating back
  refreshCount() {
    const taskId = this.data.get('taskId');
    if (taskId) {
      fetch(`/tasks/${taskId}/comments?count_only=true`, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        if (this.hasCountTarget) {
          this.countTarget.innerHTML = html;
        }
      });
    }
  }
}